'use client'

import { useState } from "react"
import Button from "@/components/button/Button"
import useEventListener from "@/components/plugins/EventListener"

export default function RecentlyViewedBadge(props) {
  
  const [selected, setSelected] = useState(props.viewed ? props.viewed.indexOf(props.vin) >= 0 : props.site.session?.vehicles?.viewed?.indexOf(props.vin) >= 0)
  
  useEventListener("visitor_viewed_badge", event => {
    if (event.detail?.vehicles?.viewed) {
      setSelected(event.detail?.vehicles?.viewed.indexOf(props.vin) >= 0)
    }
  })
  
  if (selected) {
    return <Button theme={['floating','semi-black'] } displayOnly={true} label={ 'Recently Viewed' }></Button>
  } else {
    return null
  }  
  
}